import 'slick-carousel/slick/slick'

export default class CustomCardSlider {

    constructor() {

        this.settings = {
            $slider : $('.js-custom-cards-slider')
        };

        this.bindUIActions();
    }

    bindUIActions() {

        if(this.settings.$slider.length) {
            this.settings.$slider.slick({
                autoplay: true,
                autoplaySpeed: 5000,
                slidesToShow: 3,
                slidesToScroll: 2,
                dots: true,
                prevArrow: $('.js-custom-cards-previous'),
                nextArrow: $('.js-custom-cards-next'),
                appendDots: $('.js-custom-cards-dots'),

                responsive: [
                    {
                        breakpoint: 640,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                        }
                    }
                ]
            });
        }

        const $customCards = $('.js-custom-card');

        if($customCards.length) {
            const $flipCard = $('.js-custom-card-flip');

            $flipCard.hide(); // Hide all the flip cards on page load

            // Show the flip card content on hover / tap on mobile
            $customCards.on('mouseover tap', (e) => {
                const $this = $(e.currentTarget);
                $this.find('.js-custom-card-heading').fadeOut();
                $this.find('.js-custom-card-flip').fadeIn();
            })

            $customCards.on('mouseleave tap', (e) => {
                const $this = $(e.currentTarget);
                $flipCard.fadeOut();
                $this.find('.js-custom-card-heading').fadeIn();
            })
        }

    }

};

new CustomCardSlider();